// removed by extract-text-webpack-plugin
module.exports = {"list":"CustomList__list___2O646","listItem":"CustomList__listItem___1RYrA","marginItem":"CustomList__marginItem___3lNxc","avatar":"CustomList__avatar___8pF5s","text":"CustomList__text___3NwVO","rightItems":"CustomList__rightItems___38byN","leftItems":"CustomList__leftItems___1UTQL","primaryText":"CustomList__primaryText___2ElpW","secondaryText":"CustomList__secondaryText___1UuDl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/CustomList/CustomList.scss
// module id = 1398
// module chunks = 0